<template>
  <object
    scroll="no"
    style="width: 100%; height: 100vh; overflow-x: hidden !important"
    scrolling="no"
    type="text/html"
    data="https://app.powerbi.com/view?r=eyJrIjoiN2YwM2U5NDctNDYzYy00ODQ1LWFhM2MtOTM2NzIzMTQxOTQyIiwidCI6ImMzNmJlZGI5LTAwMzgtNDM0OC1iYzRjLTg4ZWQ4MWZjMTQ1OCIsImMiOjR9"
  ></object>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "DiagnosticoCalidad",
  data() {
    return {};
  },
  computed: {
    ...mapState(["permissions"]),
  },
  mounted() {
    if (!this.permissions.includes("Diagnóstico de calidad")) this.$router.push("/dashboard");
  },
};
</script>

<style>
</style>
